import { Dialog } from "primereact/dialog"

export default function PPDeleteConfirmationModal({
    visible,
    onClose,
    onConfirm,
    title = "Regel löschen",
    message = "Sind Sie sicher, dass Sie diese Regel löschen möchten?",
    additionalMessage = null,
    confirmText = "Löschen",
    cancelText = "Abbrechen"
}) {
    return (
        <Dialog
            header={
                <span className="d-flex align-items-center">
                    <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                    {title}
                </span>
            }
            visible={visible}
            style={{ width: "32rem" }}
            onHide={onClose}
            dismissableMask
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        {cancelText}
                    </button>
                    <button type="button" className="btn btn-danger" onClick={onConfirm}>
                        <i className="fas fa-trash me-2"></i>
                        {confirmText}
                    </button>
                </div>
            }>
            <p className="mb-3">{message}</p>
            {additionalMessage && (
                <div className="alert alert-warning mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    {additionalMessage}
                </div>
            )}
            <p className="text-muted small mb-0">Diese Aktion kann nicht rückgängig gemacht werden.</p>
        </Dialog>
    )
}
